import moment from "moment";
import { FAILURE, POST, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function countNombreEmpresa(obj) {
    try {
        let data = { error: true };
        const { code, message, body } = await fetch(
            "https://gestiondeflota.boltrack.net/api-gestion-plataforma/empresa/count-nombre-empresa",
            {
                headers: getHeaders(false),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
            if (Array.isArray(body) && body.length > 0) {
                data.total = body[0].total;
            }
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("validarNit err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function countUsername(obj) {
    try {
        let data = { error: true };
        const { code, message, body } = await fetch(
            "https://gestiondeflota.boltrack.net/api-gestion-plataforma/empresa/count-username",
            {
                headers: getHeaders(false),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
            if (Array.isArray(body) && body.length > 0) {
                data.total = body[0].total;
            }
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("validarNit err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function registrarEmpresa(obj) {
    try {
        let data = { error: true };
        const { code, message, body, } = await fetch(
            "https://gestiondeflota.boltrack.net/api-gestion-plataforma/empresa/registrar-empresa",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
            data.token = body;
        }
        if (code === FAILURE) {
            data.error = true;
            alert(message);
        }
        return data;
    } catch (err) {
        console.log("registrarEmpresa err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function obtenerListaEmpresas() {
    try {
        let rows = [];
        const { code, body } = await fetch(
            "https://gestiondeflota.boltrack.net/api-gestion-plataforma/empresa/obtener-lista-empresas",
            {
                headers: getHeaders(),
                method: POST,
                // body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            rows = body;
            for (let i = 0; i < rows.length; i++) {
                rows[i].fechaModificacion = moment(rows[i].fechaModificacion).format('DD/MM/YYYY HH:mm:ss');
            }
        }
        return rows;
    } catch (err) {
        console.log("obtenerInfoEmpresa err");
        console.log(err);
        return [];
    }
}

export async function actualizarLimiteVehiculo(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            "https://gestiondeflota.boltrack.net/api-gestion-plataforma/limite-vehiculo/registrar-limite-vehiculo",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("actualizarInfoEmpresa err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function modificarEmpresa(obj) {
    try {
        let data = { error: true };
        const { code, message, body, } = await fetch(
            "https://gestiondeflota.boltrack.net/api-gestion-plataforma/empresa/modificar-empresa",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            alert(message);
        }
        return data;
    } catch (err) {
        console.log("modificarEmpresa err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function obtenerEquiposActivosPorEmpresa(obj) {
    try {
        let data = null;
        const { code, message, body, } = await fetch(
            "https://gestiondeflota.boltrack.net/api-gestion-plataforma/empresa/obtener-equipos-activos-por-empresa",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data = body;
        }
        if (code === FAILURE) {
            data.error = true;
            alert(message);
        }
        return data;
    } catch (err) {
        console.log("obtenerEquiposActivosPorEmpresa err");
        console.log(err);
        return null;
    }
}

export async function obtenerEmpresasDeEmpresaPlataforma(obj) {
    try {
        let data = [];
        const { code, message, body, } = await fetch(
            "https://gestiondeflota.boltrack.net/api-gestion-plataforma/empresa/obtener-lista-empresa-plataforma",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data = body;
            for (let i = 0; i < data.length; i++) {
                data[i].fechamodificacion = moment(data[i].fechaModificacion).format('DD/MM/YYYY HH:mm:ss');
            }
        }
        if (code === FAILURE) {
            data.error = true;
            alert(message);
        }
        return data;
    } catch (err) {
        console.log("obtenerEmpresasDeEmpresaPlataforma err");
        console.log(err);
        return [];
    }
}